import { Attributes, LookupBase, Misc } from '@singularsystems/neo-core';

export default class ParticipationAgreementLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    public participationAgreementId: number = 0;

    public fileDescriptorId: number = 0;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public uploadedOn: Date = new Date();

    public fileName: string = "";

    // Client only properties / methods
}